/**
 *  Seguramente hay alguna manera de inferir el valor de retorno de getDomainValue, pero no lo he encontrado en este momento. De todas maneras no es necesario para que funcione; pero si deseable a futuro.
 * */

type Key = 'camper' | 'nnormal' | 'camperlab';

export function getDomain(): Key {
  const currentDomain = process.env.NEXT_PUBLIC_DOMAIN;
  if (currentDomain && ['camper', 'nnormal', 'camperlab'].includes(currentDomain)) {
    return currentDomain as Key;
  }
  return 'camper';
}

export function getDomainValue<T, U, V>(
  args: {
    camper?: T;
    nnormal?: U;
    camperlab?: V;
  },
  domain = getDomain(),
): T | U | V {
  let valueToReturn = args[domain];

  // si el valor es una string que referencia a otro dominio válido y distinto, seguimos la referencia
  if (typeof valueToReturn === 'string' && ['camper', 'nnormal', 'camperlab'].includes(valueToReturn) && valueToReturn !== domain) {
    const redirectedDomain = valueToReturn as Key;
    valueToReturn = args[redirectedDomain];
  }

  if (valueToReturn === undefined) {
    return null as T | U | V;
  }

  return valueToReturn as T | U | V;
}

export function isDomain(...domains: ('camper' | 'nnormal' | 'camperlab')[]) {
  return domains.includes(getDomain());
}
